// extracted by mini-css-extract-plugin
export default {"brief-live-widget__container":"styles_brief-live-widget__container__OhgO2","brief-live-widget__content":"styles_brief-live-widget__content__v9ji+"};